var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BreadBrowseTable',{attrs:{"role":"Moderator","model":_vm.model,"url":((_vm.$api.servers.log) + "/log/v1/" + (this.$_getLocale()) + "/activity/student/" + (_vm.parent.id) + "/browse")}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }